import Select, { components } from "react-select";
import React from "react";
import Checkbox from "./checkbox";
import Drawer from "./drawer";

function CustomOption(props) {
    const {
        innerProps,
        getStyles,
        isDisabled,
        isFocused,
        children,
        isSelected,
        matchedRecords,
    } = props;
    return (
        <components.Option
            {...props}
            isDisabled={isDisabled}
            getStyles={getStyles}
            className="tw-flex tw-items-center tw-text-inherit tw-py-0 tw-px-4 !tw-outline-transparent !tw-bg-transparent"
            innerProps={{
                ...innerProps,
                backgroundColor: isFocused ? "#fff" : "transparent",
            }}
        >
            <div className="tw-flex tw-py-3 tw-w-full tw-border-0 tw-border-b tw-border-solid tw-border-light-gray">
                <Checkbox checked={isSelected} disabled={isDisabled} />
                <span className="tw-ml-3 tw-whitespace-pre-wrap tw-max-w-[66%]">{children}</span>
                <span className="tw-absolute tw-right-4 tw-text-gray">{matchedRecords}</span>
            </div>
        </components.Option>
    );
}

function countMatchedRecords(props, jobs) {
    return jobs.filter((job) => job.includes(props.data.value)).length;
}

function getFilterClasses() {
    return {
        dropdownIndicator: (state) => {
            let classes = [
                "tw-transition-all",
                "!tw-duration-200",
                "!tw-text-white",
                "hover:!tw-text-white",
                "focus:!tw-text-white"
            ];

            if (state.selectProps.menuIsOpen) {
                classes.push("!tw-transform !tw-rotate-180");
            }

            return classes.join(' ');
        },
        control: () => (
            "!tw-bg-main !tw-text-white !tw-rounded-lg !tw-border-2 !tw-border-white"
        ),
        menu: () => (
            "!tw-mt-3 !tw-bg-white !tw-text-main !tw-overflow-hidden !tw-rounded-2xl"
        ),
        menuList: () => "!tw-max-h-none tw-overflow-y-hidden !tw-pb-6 md:tw-overflow-y-auto md:!tw-max-h-[300px] md:!tw-pb-1",
        placeholder: () => (
            "!tw-text-white"
        ),
        option: () => (
            "!tw-text-main !tw-border-gray"
        )
    }
}

function Filter({ allOptions, eventHandler, placeholder, selectedOptions, jobs }) {
    let layoutMobileBreakPoint = 768;

    return (
        <Select
            defaultValue={[]}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            onChange={(options) => {
                if (Array.isArray(options)) {
                    eventHandler(options.map((opt) => opt.value));
                }
            }}
            onMenuOpen={() => {
                if (window.innerWidth < layoutMobileBreakPoint) {
                    document.body.style.overflowY = 'hidden';
                }
            }}
            onMenuClose={() => {
                if (window.innerWidth < layoutMobileBreakPoint) {
                    document.body.style.overflowY = 'auto';
                }
            }}
            options={allOptions}
            className="tw-mr-4 tw-mb-2 tw-float-left tw-w-full md:tw-w-[320px]"
            isClearable={false}
            components={{
                Option: (props) => (
                    <CustomOption
                        {...props}
                        isSelected={selectedOptions.includes(props.data.value)}
                        matchedRecords={countMatchedRecords(props, jobs)}
                        isDisabled={countMatchedRecords(props, jobs) === 0}
                    />
                ),
                IndicatorSeparator: () => null,
                Menu: (props) => (
                    window.innerWidth >= layoutMobileBreakPoint ?
                        <components.Menu {...props} /> :
                        <Drawer title={placeholder.props.children}>
                            <components.Menu
                                {...props}
                                className="!tw-relative !tw-top-0 !tw-rounded-none !tw-shadow-none"
                            />
                        </Drawer>
                )
            }}
            styles={{
                menuList: (base) => ({
                    ...base,
                    height: "-webkit-fill-available"
                })
            }}
            classNames={getFilterClasses()}
            placeholder={placeholder}
            controlShouldRenderValue={false}
        />
    );
}

export default Filter;
export { CustomOption };